module.exports = "/_next/static/images/Pinnacle-8b07c8a513148806dbaf423d7c1e1794.png";